import styles from "./CharCounter.module.scss";

// FE-SH CharCounter (Forms — CharCounter 0/40, 0/125). A live count shown beside a field's label; goes
// danger when over the max (the field itself carries maxLength, so "over" is a soft guard for pasted text).
export function CharCounter({ count, max }: { count: number; max: number }) {
  return (
    <span className={styles.counter} data-over={count > max || undefined} aria-hidden="true">
      {count}/{max}
    </span>
  );
}
